import 'apis/sentry';
import { publishActivation } from 'apis/pubsub';
import { getTokens } from 'utils/auth';
import { hasRegistry } from 'apis/registry';
import { reportError } from 'apis/sentry';
import { allowedHost } from 'utils/settings';
import {
  checkConsent,
  consentCategories,
  getCookie,
  setCookie,
} from 'utils/cookies';

const init = () => {
  if (window.location.hostname !== allowedHost) {
    return;
  }

  const STORAGE_KEY = `igift-agent`;
  let cachedUserId = getCookie(STORAGE_KEY);
  let userId: string = '';
  const DISABLED = 'disabled';

  const disable = () => {
    // Existing buttons will remain until page reload
    setCookie(STORAGE_KEY, DISABLED, 7);
  };

  getTokens()
    .then((user) => {
      userId = user.id;

      if (cachedUserId === userId) {
        publishActivation();
      } else if (!user.guest && user.id) {
        /*
          Only check for authenticated users that have partyUId.
          Guest users need to visit their gift registry to have the button enabled.
          Authenticated users without partyUId shouldn't see the button.
        */
        return hasRegistry().then(
          ({
            data: {
              activeRegistry: { __typename },
            },
          }) => {
            if (__typename === 'ActiveRegistryPayload') {
              setCookie(STORAGE_KEY, userId, 7);
              publishActivation();
            } else if (__typename === 'NotFoundError') {
              disable();
            } else if (__typename === 'SuspendedRegistryError') {
              disable();
            } else {
              disable();
              throw new Error(`Unhandled __typename ${__typename}`);
            }
          }
        );
      } else {
        disable();
      }
    })
    .catch((err) => {
      console.error('[igift] Failed to initialize', err);
      reportError(err);
    });

  window.ikea = window.ikea || {};
  window.ikea.giftRegistry = window.ikea.giftRegistry || {};
  window.ikea.giftRegistry.enable = () => {
    setCookie(STORAGE_KEY, userId, 7);
    cachedUserId === DISABLED && publishActivation();
    cachedUserId = userId;
  };
  window.ikea.giftRegistry.disable = disable;
};

// In reality this should always be true but what the heck.
if (checkConsent(consentCategories.strictlyNecessaryCookies)) {
  init();
}
